import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { MessageCard } from '../message-card/message-card';

import * as Styles from './message-option.module.scss';

interface MessageOptionProps {
    active?: boolean;
    onClick?: () => void;
    className?: string;
    disabled?: boolean;
}

export const MessageOption: FC<PropsWithChildren<MessageOptionProps>> = ({
    children,
    onClick,
    active,
    disabled,
    className,
    ...rest
}) => {
    return (
        <MessageCard
            {...rest}
            onClick={onClick}
            className={classNames(
                {
                    [Styles.active]: active,
                    [Styles.disabled]: disabled,
                },
                Styles.messageOption,
                className
            )}
        >
            {children}
        </MessageCard>
    );
};
